export default class BottomModalIcon {
    constructor( props ) {
        this.type    = props.type;
        this.content = props.content;
        this.background = props.background;
    }
}
